var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-btn',{staticClass:"btn-secondary",attrs:{"text":"Pobierz listę aktywnych promocji","icon":"Download","loading-status":_vm.status},nativeOn:{"click":function($event){return _vm.downloadActivePromos.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }